import React,{useEffect, useState} from "react";
import "../create/create.css";
import Head from "../../Header/head";
import {useForm} from "react-hook-form";
import axiosInstance from "../../../services/axios";
import { toSeconds } from "../../../utils/utils";
import { Link } from "react-router-dom";
import AdvanceDebate from "../../../Forms/advance";
import OrganisedDebate from "../../../Forms/organised";
import FreestyleDebate from "../../../Forms/freestyle";
import { useDispatch,useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { get_user_subscription } from "../../../redux/actions/get_user_subscription";

function Create(){
    const dispatch = useDispatch();
    const [Form, setForm] = useState("freestyle");
    const [serviceList, setServiceList] = useState([{ service: "" }]);
    const [formValues, setFormValues] = useState([{ action: "", is_voting_allow: "",section:"",hour:"",minutes:""}]);
    const auth = useSelector((state)=>state.jwtAuthreducer);
    const subscriptions = useSelector((state)=>state.getUserSubscriptionDetails);
    const navigate = useNavigate();
    console.log(subscriptions.subscriptions,"from create")

    useEffect(()=>{
        if(subscriptions.subscriptions === null){
            dispatch(get_user_subscription());

        }
    },[subscriptions])
    
    let handleChange = (i, e) => {
        let newFormValues = [...formValues];
        newFormValues[i][e.target.name] = e.target.value;
        setFormValues(newFormValues);
    }

    let addFormFields = () => {
        setFormValues([...formValues, { action: "", is_voting_allow: "",section:"",hour:"",minutes:""}])
    }
    
    let removeFormFields = (i) => {
        let newFormValues = [...formValues];
        newFormValues.splice(i, 1);
        setFormValues(newFormValues)
    }
    
    const switchForm = (event)=>{
        setForm(event.target.value);
    }

    const handleServiceAdd = () => {
        setServiceList([...serviceList, { service: "" }]);
    };

    const {
        handleSubmit,
        register,
        formState: { errors, isSubmitting},
    }=useForm();
   
    
    const onSubmitAdvance = async(values) => {
        console.log("inside advance submit")
        console.log(values)
    }
    const [selectedOption, setSelectedOption] = useState('freestyle');

  // Change handler function to update the state when the radio button changes
    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };
    
    

    return(
        <>
        {auth.isAuthenticated === false
        ?
        navigate("/login")
        :
        <div>
            <Head/>
            <div className="inner-page-wrapper">
                <div className="step-header">
                    <div className="container d-flex">
                        <div className="step-header-title">
                            Get Started
                        </div>

                        <div className="step-header-text">
                            <span>Step 2:</span> Provide debate competition details
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-step form-step-2" id="formated_debate">
                <div className="container">
                    <div className="form-step-row form-step-first-row">
                            <div className="form-row-left">
                                <label>Type of debate</label>
                            </div>
                            <>
                            {subscriptions.subscriptions ?
                            <>
                             <div className="form-row-right">
                            {subscriptions.subscriptions.map((item,index)=>
                             <div className="radio-input">
                                 <input type="radio" id={item} name="debateType"  value={item} onClick={switchForm}   checked={selectedOption === `${item}`}           onChange={handleOptionChange} />
                                 <label htmlFor={item}>{item}</label>
                             </div>

                            //  {/* <div className="radio-input">
                            //      <input type="radio" id="Intermediate" name="debateType" value="Intermediate" onClick={switchForm}  checked={selectedOption === 'Intermediate'}           onChange={handleOptionChange}/>
                            //      <label htmlFor="Intermediate">Intermediate &nbsp;</label>
                            //  </div>

                            //  <div className="radio-input">
                            //      <input type="radio" id="advance" name="debateType" value="advance" onClick={switchForm} checked={selectedOption === 'advance'}           onChange={handleOptionChange}/>
                            //      <label htmlFor="advance">Advance</label>
                            //  </div> */}
                            )}
                            </div>

                            </>
                            :
                            "Loading..."
                            }
                           
                            </>

                    </div>

                    {Form == "freestyle" ? <FreestyleDebate/>:""}
                    {Form == "intermediate" ? <OrganisedDebate/>:""} 
                    {Form == "advance" ? <AdvanceDebate/>:""}

           
             
            
            </div>
        </div>

        

        

        </div>
        }
        </>

    );
}

export default Create;